import isNumber from './is-number';

export default function styleValue(value) {
    if (isNumber(value)) {
        return value + "px";
    }
    return value;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@progress/kendo-react-gauges/node_modules/@progress/kendo-charts/dist/es/common/style-value.js
// module id = 955
// module chunks = 29